export default __webpack_public_path__ + "static/bg-edc896451062c47dc324457dc6325303.png";